/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-04 14:01:07
 * @LastEditors: K
 * @LastEditTime: 2022-09-01 15:54:19
 */
import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, Input, Row, Space } from 'antd';
import React, {
  ReactElement,
  useEffect,
  useState,
} from 'react'
import styles from "./sendMessagePage.module.css";
import { Columns } from './columns'
import { unwrapResult } from '@reduxjs/toolkit';
import { getSendMessageList } from '../sendMessageSlice';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../../app/store';
import { DateRangeType, DateSelect, getDateRange } from '../../../../compnents/form/DateSelect';
import { EditableList } from '../../../../compnents/list/EditableList';
export const SendMessagePage = () => {
  const dispatch = useDispatch<RootDispatch>()
  const [form] = Form.useForm()

  const [head, tail] = getDateRange(DateRangeType.ThisWeek);

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
    startTime: head,
    endTime: tail,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  useEffect(() => {
    form.submit()
  }, [])
  const getPage = () => {
    dispatch(getSendMessageList(params))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res.total,
          items: res.records
        })
      })
      .catch(() => {
        // do nothing.
      });
  }
  useEffect(() => {
    params.current != 0 && getPage()
  }, [params])
  const [pageLoading, setPageLoading] = useState(false)
  return (
    <div className={styles.wrap}>
      {/* 查询区域 */}
      <Form form={form} onFinish={(values) => {
        setParams({
          ...params,
          ...values,
          startTime: values.actionTimeHead ? values.actionTimeHead : params.startTime,
          endTime: values.actionTimeTail ? values.actionTimeTail : params.endTime,
          actionTimeHead: undefined,
          actionTimeTail: undefined,
          current: 1
        })
      }}>
        <Row style={{ marginTop: 10, marginBottom: 20 }} justify='space-between'>
          <Space>
            <Form.Item noStyle name='templateName'>
              <Input
                autoComplete='off'
                prefix={<SearchOutlined />}
                placeholder='输入短信内容/机构名称/接收方手机号'
                style={{ width: '16rem' }}
                allowClear
                onChange={() => form.submit()}
              />
            </Form.Item>
            <DateSelect
              style={{ width: '8.5rem' }}
              allowClear={false}
              labelPrefix='时间范围-'
              namePrefix='actionTime'
              placeholder='时间范围-时间'
              initialValue={DateRangeType.ThisWeek}
              onChange={() => form.submit()}
            />
          </Space>
          <Button type='primary' htmlType='submit'>
            查询
          </Button>
        </Row>
      </Form>

      {/* 表格区域 */}
      <EditableList
        loading={pageLoading}
        page={{
          current: params.current,
          size: params.size,
          total: page.total,
          items: page.items,
        }}
        columns={Columns(
          params.size * (params.current - 1),
        )}
        onChangePage={(current: any, size: any) =>
          setParams({
            ...params,
            current,
            size: size || 10,
          })
        }
        onRow={() => ({
          onDoubleClick: () => {
            console.log(1);

          },
        })}
      />
    </div>
  );
}



